
<template>
    <div class="collectView">
        <div class="collectBlock">
            <div class="top">
                <div class="topA">我的收藏</div>
                <div class="topB">
                    <!-- type_data 类型:1=资源,2=试题,3=班会 -->
                    <div :class="idx == 1 ? 'topB1' : 'topB2'" @click="goTab(1)">资源</div>
                    <div :class="idx == 2 ? 'topB1' : 'topB2'" @click="goTab(2)">试题</div>
                    <div :class="idx == 3 ? 'topB1' : 'topB2'" @click="goTab(3)">班会</div>
                </div>
            </div>

            <div class="tabView" v-for="(item, index) in pageList" :key="index">
                <div class="tabViewBlock">
                    <div class="tabList">
                        <!-- <img class="tabImg" :src="item.school_source.head_image" alt="" /> -->
                        <img class="tabImg" v-bind:src="$getImageUrl(item.school_source.annex_file)" alt="" />

                        <div class="tabMid">
                            <div class="tabMidT1">{{ item.school_source.title }}</div>
                            <div class="tabMidT2">
                                <div class="tabMidT2" v-if="item.type_data == '1'">
                                    <div class="shengye">
                                        <span>学科：{{ (item.school_source.school_subject || {}).name }}</span>
                                        <span style="margin-left: 14px;">学段：{{ (item.school_source.school_subject ||
                                            {}).grade_text }}</span>
                                        <span style="margin-left: 14px;">资源类型：{{ item.school_source.source_data_text
                                        }}</span>
                                        <span style="margin-left: 14px;">章节单元：{{ (item.school_source.school_unit ||
                                            {}).name
                                        }} {{ (item.school_source.school_chapter ||
    {}).chapter_name
}}</span>
                                    </div>
                                    <div>
                                        <span>作者：{{ item.school_source.user.username }}</span>
                                        <span style="margin-left: 14px;">上传时间：{{ item.school_source.createtime }}</span>
                                    </div>
                                </div>

                                <div class="tabMidT2" v-if="item.type_data == '2'">
                                    <span>上传时间：{{ item.school_source.createtime }}</span>
                                    <span style="margin-left: 14px;">作者：{{ item.school_source.user.username }}</span>
                                    <span style="margin-left: 14px;">学段：{{ (item.school_source.school_subject ||
                                        {}).period_text }} {{ (item.school_source.school_subject ||
        {}).grade_text }}</span>
                                    <span style="margin-left: 14px;">学科：{{ (item.school_source.school_subject ||
                                        {}).name }}</span>
                                    <span style="margin-left: 14px;">类型：{{ (item.school_source.school_question_type ||
                                        {}).name }}</span>
                                </div>

                                <div class="tabMidT2" v-if="item.type_data == '3'">
                                    <span>类型：{{ item.school_source.class_meet_type == '1' ? "班会" :
                                        item.school_source.class_meet_type
                                            == '2' ? "家长会" :
                                            item.school_source.class_meet_type == '3' ? "班主任管理" : ""
                                    }}</span>
                                    <span v-if="item.school_source.class_meet_type == '1'">({{
                                        item.school_source.class_meet_catgory == '1' ? "安全类" :
                                        item.school_source.class_meet_catgory
                                            == '2' ? "教育类" :
                                            item.school_source.class_meet_catgory == '3' ? "文化类" : ""
                                    }})</span>
                                    <span style="margin-left: 14px;">作者：{{ item.school_source.user.username }}</span>
                                    <span style="margin-left: 14px;">上传时间：{{ item.school_source.createtime }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tabR" @click="cancelCollect(item)">取消收藏</div>
                </div>
                <div class="line"></div>
            </div>

            <el-empty v-if="!pageList.length" description="快去查看资源、试题、班会吧" style="margin-top: 200px;" />

            <!-- <div class="tabView">
                <div class="tabViewBlock">
                    <div class="tabList">
                        <img class="tabImg" src="../../assets/images/mine/a11.png" alt="" />
                        <div class="tabMid">
                            <div class="tabMidT1">2022 2023年新教材高中语文第一单元学业检测试题</div>
                            <div class="tabMidT2">
                                <span>学科：语文</span>
                                <span style="margin-left: 24px;">学段：六年级</span>
                                <span style="margin-left: 24px;">资源类型：课件</span>
                                <span style="margin-left: 24px;">章节单元：第一单元</span><br />
                                <span>作者：朱自清</span>
                                <span style="margin-left: 24px;">上传时间：2023-4-13</span>
                            </div>
                        </div>
                    </div>
                    <div class="tabR">取消收藏</div>
                </div>
                <div class="line"></div>
            </div> -->

            <div class="paginationView">
                <pagination v-if="total" :page.sync="page" :pageSize.sync="pageSize" :total="total" @change="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
export default {
    components: { Pagination },
    data() {
        return {
            page: 1,
            pageSize: 10,
            total: 0,
            currentPage4: 4,
            idx: 1, //type_data 类型:1=资源,2=试题,3=班会
            pageList: [],
        }
    },
    mounted() {
        // 收藏列表
        const query = this.$route.query;
        this.page = +query.page || 1;
        this.pageSize = +query.size || 10;
        this.getfollowList();
    },
    created() {
    },
    methods: {
        async cancelCollect(info = {}) {
            try {
                const res = await this.$post('person_center/follow', { id: info.school_source.id });
                if (res.code == 0) {
                    this.$message.error(res.msg)
                } else {
                    this.$message.success(res.msg);
                    this.getfollowList();
                }

            } catch (error) { }
        },
        // 切换类型
        goTab(e) {
            this.idx = e;
            this.page = 1;
            this.getfollowList();
        },
        /** 分页改变 */
        pageChange() {
            this.$router.replace(`/mine/index?page=${this.page}&size=${this.pageSize}`);
            this.getfollowList();
        },
        // 收藏列表 tianyue.com/api/person_center/followList?type_data=2
        /** 获取内容 */
        async getfollowList() {
            this.pageLoading = true;
            try {
                const res = await this.$get('person_center/followList', {
                    pageNum: this.page,
                    pageSize: this.pageSize,
                    type_data: this.idx
                })
                this.pageList = res.data.data || [];
                this.total = res.data.total || 0;
                console.warn(this.pageList, "res")
            } catch (error) { }
            this.pageLoading = false;
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
    },
}
</script>

<style lang='scss' scoped>
.collectView {
    width: 100%;

    .collectBlock {
        margin: 37.5px 39px 163px 40px;

        .top {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .topA {
                font-size: 20px;
                font-family: PingFang SC, PingFang SC-Semibold;
                font-weight: 600;
                color: #333333;
            }

            .topB {
                display: flex;

                .topB1 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 98px;
                    height: 32px;
                    border: 1px solid #d9242a;
                    background: #d9242a;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #ffffff;
                }

                .topB2 {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #d9242a;
                    background: #ffffff;
                    border: 1px solid #d9242a;
                    width: 98px;
                    height: 32px;
                }
            }
        }

        .paginationView {
            height: 100px;
            margin-top: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .tabView {
            margin: 28px 0 0 0;

            .line {
                margin-top: 28px;
                width: 880px;
                height: 2px;
                background: #f2f2f2;
            }

            .tabViewBlock {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tabList {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 90%;

                    .tabImg {
                        width: 72px;
                        height: 72px;
                    }

                    .tabMid {
                        margin-left: 32px;

                        .tabMidT1 {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            /*控制在3行*/
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;

                            font-size: 24px;
                            font-family: PingFang SC, PingFang SC-Semibold;
                            font-weight: 600;
                            color: #333333;
                        }

                        .tabMidT2 {
                            width: 680px;
                            margin-top: 16px;
                            line-height: 20px;
                            font-size: 16px;
                            font-family: PingFang SC, PingFang SC-Regular;
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                }

                .tabR {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 400;
                    color: #d9242a;
                    width: 74px;
                    height: 32px;
                    background: #ffffff;
                    border: 1px solid #d9242a;
                }
            }
        }
    }
}

.shengye {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*控制在3行*/
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
</style>
